import AnimationClip, { AnimationClipEvent } from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import Sprite from '../../../Prototype/Sprite';
import { Point } from 'pixi.js';
import { AwaitIterators } from '../AnimationHelper';
import { delay } from '../../../Utility/Task/TaskQueue';
import Renderable from '../../../Component/Renderable';
import {
    createAlphaTween,
    createScaleTween,
    getTweenProps,
} from '../AnimationTweenHelper';

// this Animationclip is also used for ThreePlusCardEffect

export class BoomExplosionEffect extends AnimationClip {
    *execute() {
        try {
            yield* AwaitIterators([
                this.cardEffect(),
                this.explosion(100),
                this.explosion(400),
            ]);
            this.gameObject.destroy();
        } catch (e) {
            console.error(e);
        }
    }

    *cardEffect(): IterableIterator<number> {
        const card = GameObject.Instantiate(Sprite, {
            texture: 'blue-card-vfx',
            anchor: new Point(0.5, 0.5),
        });
        this.gameObject.addChild(card);

        const cardAlphaTween = createAlphaTween({
            ...getTweenProps(card, this, { alpha: 0 }),
            duration: 400,
        });
        const cardScaleTween = createScaleTween({
            ...getTweenProps(card, this, new Point(0, 0)),
            duration: 400,
        });
        yield* AwaitIterators([
            this.startTween(cardAlphaTween),
            this.startTween(cardScaleTween),
        ]);
    }

    *explosion(delayTime: number): IterableIterator<number> {
        yield* delay(delayTime);
        try {
            const haloCore = GameObject.Instantiate(Sprite, {
                texture: 'halo-core',
                anchor: new Point(0.5, 0.5),
                scale: new Point(0, 0),
            });
            haloCore.addComponent(Renderable);

            const haloAura = GameObject.Instantiate(Sprite, {
                texture: 'halo-aura',
                anchor: new Point(0.5, 0.5),
                scale: new Point(0, 0),
            });
            haloAura.addComponent(Renderable);

            const haloRing = GameObject.Instantiate(Sprite, {
                texture: 'halo-ring',
                anchor: new Point(0.5, 0.5),
                scale: new Point(0, 0),
            });
            haloRing.addComponent(Renderable);

            this.gameObject.addChild(haloCore);
            this.gameObject.addChild(haloAura);
            this.gameObject.addChild(haloRing);

            const haloCoreScaleTween = createScaleTween({
                ...getTweenProps(haloCore, this, new Point(1.5, 1.5)),
                duration: 400,
            });

            const haloCoreAlphaTween = createAlphaTween({
                ...getTweenProps(haloCore, this, { alpha: 0 }),
                duration: 600,
            });

            const haloAuraScaleTween = createScaleTween({
                ...getTweenProps(haloAura, this, new Point(2.1, 2.1)),
                duration: 500,
            });

            const haloAuraAlphaTween = createAlphaTween({
                ...getTweenProps(haloAura, this, { alpha: 0 }),
                duration: 700,
            });

            const haloRingScaleTween = createScaleTween({
                ...getTweenProps(haloRing, this, new Point(2.2, 2.2)),
                duration: 600,
            });

            const haloRingAlphaTween = createAlphaTween({
                ...getTweenProps(haloRing, this, { alpha: 0 }),
                duration: 800,
            });
            yield* AwaitIterators([
                this.startTween(haloCoreScaleTween),
                this.startTween(haloCoreAlphaTween),
                this.startTween(haloAuraScaleTween),
                this.startTween(haloAuraAlphaTween),
                this.startTween(haloRingScaleTween),
                this.startTween(haloRingAlphaTween),
            ]);
        } catch (e) {
            console.error(e);
        }

        yield;
    }
}
